// The keys that switch on selecting on the planning map while held, without Leaflet so they can be unit tested:
// Shift selects with a box, Control with the free-hand lasso. On a Mac Command does the lasso as well, as Ctrl+click
// is a right click there.

/** 'box': a rectangle from where the mouse went down to where it is, 'lasso': a free-hand area */
export type SelectionShape = 'box' | 'lasso'

/** Whether the browser runs on macOS (or iOS) */
export function isMacPlatform(userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent) {
    return /Mac|iPhone|iPad/.test(userAgent)
}

/** The shape a held key selects with, null for other keys */
export function selectionShapeOfKey(key: string, mac: boolean): SelectionShape | null {
    if (key === 'Shift') {
        return 'box'
    }

    return key === 'Control' || (mac && key === 'Meta') ? 'lasso' : null
}

/** The name of the lasso key in a tooltip */
export function lassoKeyLabel(mac: boolean) {
    return mac ? 'Cmd' : 'Ctrl'
}

/** The held selection keys in the order they went down, with key added; a key that repeats keeps its place */
export function pressSelectionKey(held: string[], key: string) {
    return held.includes(key) ? held : [...held, key]
}

export function releaseSelectionKey(held: string[], key: string) {
    return held.includes(key) ? held.filter((heldKey) => heldKey !== key) : held
}

/**
 * The shape the map selects with: the last pressed of the held keys wins (Shift and then Ctrl held: the lasso),
 * without keys the mode of the toolbar. Null when the map just pans.
 */
export function activeSelectionShape(mode: SelectionShape | null, held: string[], mac: boolean): SelectionShape | null {
    for (let i = held.length - 1; i >= 0; i--) {
        const shape = selectionShapeOfKey(held[i], mac)

        if (shape) {
            return shape
        }
    }

    return mode
}
